export function getTimePercent(time: number, endTime: number) {
  return endTime ? Math.min((100 / endTime) * time, 100) : 0;
}

export function getTimeProgress(time: number, endTime: number) {
  return endTime ? Math.min(time / endTime, 1) : 0;
}

export function getTimeStr(_second: number, useMinTwoDigitInHour?: boolean) {
  // second로 받은 값이 소수점을 포함할 수 있기 때문에 반올림함
  const second = Math.round(_second);
  const sec = String(second % 60).padStart(2, '0');
  let min = String(Math.floor(second / 60) % 60);
  if (second < 60 * 60) {
    if (useMinTwoDigitInHour) {
      min = min.padStart(2, '0');
    }
    return `${min}:${sec}`;
  } else {
    if (min.length === 1) {
      min = `0${min}`;
    }
    const hour = String(Math.floor(second / 3600));
    return `${hour}:${min}:${sec}`;
  }
}
